export default [
    {
      path: "my-wallet",
      name: "my-wallet",
      component: () => import("./index"),
      meta: {
        sort: -1,
        visible: true,
        icon: "wallet",
        isNew: true,
        breadcrumb: {
          title: "Minha Carteira",
          icon: "wallet",
          name: "my-wallet",
          path: "/my-wallet"
        }
      }
    },
    {
      path: "payment-details/:id",
      name: "payment-details",
      component: () => import("./components/PaymentDetails.vue")
    },
  ];
  